import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import HSAxios from "../HSAxios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import PaymentStatusModal from "./PaymentStatusModal";

export default function Otpform() {
  const [otp, setOTP] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [title, setTitle] = useState("");
  const [btnTitle, setBtnTitle] = useState(null);
  const [show, setShow] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const doLogin = () => {
    let loginUrl = "api/admin/owner/verify/otp";
    setBtnLoading(true);

    HSAxios.post(loginUrl, {
      phone_number: location.state.phone,
      otp: otp,
    })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          console.log(response);
          Cookies.set("token", response.token);
          if (Cookies.get("token")) {
            setMsg("Login Successful! Redirecting...");
            setTitle("Success");
            setIsSuccess(true);
            setShow(true);

            console.log(response);
            setTimeout(() => {
              if (response.firsttime === 0) {
                navigate("/profile/update");
              } else {
                navigate("/", {});
              }
            }, 3000);

            // setTimeout(() => navigate("/profile/update", {}), 2000);
          } else {
            console.log("Cookie does not contain token yet");
          }
        } else {
          setMsg("Login failed! Please try again.");
          setTitle("Error");
          setIsSuccess(false);
          setShow(true);
          // setTimeout(() => {
          //   navigate("/login", {});
          // }, 3000);
        }
      })
      .catch((err) => {
        console.log("login failed ", err);
        setMsg(
          "Login failed! Please try again. Redirecting to login page in 3 seconds"
        );
        setTitle("Error");
        setIsSuccess(false);
        setShow(true);
        setTimeout(() => {
          navigate("/login", {});
        }, 3000);
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  useEffect(() => {
    const token = Cookies.get("token");

    if (token) {
      navigate("/", {});
    }
  }, [navigate]);

  const resendOtp = () => {
    let resendUrl = "api/admin/owner/get/otp?number=" + location.state.phone;

    setResendLoading(true);
    HSAxios.post(resendUrl)
      .then((response) => {
        setResendLoading(false);
        if (response.status === 200) {
          console.log("OTP resent successfully");
        }
      })
      .catch((err) => {
        setResendLoading(false);
        console.log("Failed to resend OTP", err);
      });
  };

  return (
    <div className="container mt-5 d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
      <PaymentStatusModal
        msg={msg}
        show={show}
        title={title}
        isSuccess={isSuccess}
        btnTitle={btnTitle}
        paymentHandler={null}
        onClose={() => setShow(false)}
      />
      <Card
        className="shadow-lg border-0"
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "20px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
          e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.1)";
        }}
      >
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <img
              src="admin_logo.png"
              alt="Logo"
              style={{
                height: "90px",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
            />
            <h4 className="mt-3 fw-bold" style={{ color: "#760B0B" }}>Verify OTP</h4>
            <p className="text-muted small">Enter the OTP sent to your phone</p>
          </div>
          <Form className="mt-3">
            <Form.Group className="mb-3">
              <Form.Label className="text-start fw-semibold mb-2" style={{ color: "#333" }}>
                OTP Number
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter 6-digit OTP"
                onChange={(event) => setOTP(event.target.value)}
                maxLength="10"
                className="py-2 text-center"
                style={{
                  borderRadius: "10px",
                  border: "2px solid #e0e0e0",
                  fontSize: "20px",
                  letterSpacing: "8px",
                  fontWeight: "bold",
                  transition: "border-color 0.3s ease",
                }}
                onFocus={(e) => e.target.style.borderColor = "#8B0000"}
                onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
              />
            </Form.Group>

            <div className="d-grid gap-2 mt-4">
              <Button
                className="py-2 fw-semibold"
                style={{
                  backgroundColor: "#8B0000",
                  borderColor: "#8B0000",
                  borderRadius: "10px",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(139, 0, 0, 0.3)",
                }}
                onClick={() => doLogin()}
                type="button"
                disabled={btnLoading}
                onMouseEnter={(e) => {
                  if (!btnLoading) {
                    e.target.style.backgroundColor = "#A00000";
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(139, 0, 0, 0.4)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!btnLoading) {
                    e.target.style.backgroundColor = "#8B0000";
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(139, 0, 0, 0.3)";
                  }
                }}
              >
                {btnLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
              </Button>
            </div>

            <div className="d-grid gap-2 mt-3">
              <Button
                variant="outline-danger"
                className="py-2 fw-semibold"
                style={{
                  borderColor: "#8B0000",
                  color: "#8B0000",
                  borderRadius: "10px",
                  fontSize: "16px",
                  transition: "all 0.3s ease",
                }}
                type="button"
                onClick={resendOtp}
                disabled={resendLoading}
                onMouseEnter={(e) => {
                  if (!resendLoading) {
                    e.target.style.backgroundColor = "#8B0000";
                    e.target.style.color = "white";
                    e.target.style.transform = "translateY(-2px)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!resendLoading) {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#8B0000";
                    e.target.style.transform = "translateY(0)";
                  }
                }}
              >
                {resendLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Resending...
                  </>
                ) : (
                  "Resend OTP"
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
